import RestClient from './rest-client'

export default class SystemSetting extends RestClient {
  static get url () {
    return this.apiUrl + '/system_settings'
  }
  
  static get paramKey () {
    return 'system_setting'
  }
}
